import {Component, OnInit, Input} from '@angular/core';
import {WindowRefService} from '@app/core';
import {size} from 'lodash';

@Component({
    selector: 'app-pay-zone-form',
    templateUrl: './pay-zone-form.component.html',
    styleUrls: ['./pay-zone-form.component.scss']
})
export class PayZoneFormComponent implements OnInit {

    readonly _TYPE_CARD_NATIONAL = 'cardnational';
    readonly _TYPE_CARD_INTERNATIONAL = 'cardinternational';

    @Input() infoModePayement: Array<any>;
    payzoneToggledVal: Number = null;
    payzoneTypeVal: Number = null;
    constructor(private winRef: WindowRefService) {}

    ngOnInit() {
        if (size(this.infoModePayement) == 1) {
            this.payzoneToggledVal = this.infoModePayement[0];
        }
    }


    submit(val) {
        window.location.href = val.action;
    }

    /**
     * get taux de change
     * @returns number
     */
    get Cpercente(): number {
        return this.winRef.appConfigSite.Cpercente;
    }

    /**
     * get currency
     * @returns string
     */
    get Ccurrency(): string {
        return this.winRef.appConfigSite.Ccurrency;
    }
}
